import {BlockComponentProps} from 'client-react-block-renderer';
import React, {Component} from 'react';
import {SearchBoxController, SearchBoxControllerProps} from 'search-rat';

interface Props extends BlockComponentProps<{}, SearchBoxControllerProps> { }

export default class BlockSiteSearchBox extends Component<Props> {
    public render() {
        const instanceConfig = this.props.config;
        return (<SearchBoxController {...instanceConfig} />);
    }
}
